import script from "./VBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VBoard.vue?vue&type=script&setup=true&lang=ts"

import "./VBoard.vue?vue&type=style&index=0&id=a880cda4&lang=scss"

const __exports__ = script;

export default __exports__